import { StatCard } from '@/components/StatCard';
import { fieldLabel } from '@/features/decisions/config/fieldLabels';
import { policyName } from '@/features/decisions/config/personaContext';
import type { ReplenishmentSummary } from '@/features/decisions/decisions.api.types';

interface ActivePlanningKpisProps {
  summary: ReplenishmentSummary | undefined;
  metric: string | undefined;
  isLoading: boolean;
  error: Error | null;
  period: string;
  refExperimentId: string;
  experimentId: string;
}

export function ActivePlanningKpis({
  summary,
  metric,
  isLoading,
  error,
  period,
  refExperimentId,
  experimentId,
}: ActivePlanningKpisProps) {
  const effectiveMetric = metric ?? 'reorder_qty';
  const metricColumn =
    effectiveMetric === 'reorder_qty'
      ? 'model_order_constrained'
      : effectiveMetric === 'reorder_point'
        ? 'model_target_inv_pos'
        : effectiveMetric;
  const stateSuffix = isLoading
    ? ' · loading…'
    : error
      ? error.message.includes('no data')
        ? ' · no data for selected date'
        : ' · query failed'
      : '';
  const comparedTag = (
    <span className="text-[10px] text-gray-500">
      <span className="font-medium text-gray-600">{policyName(experimentId)}</span> vs{' '}
      {policyName(refExperimentId, true)} · by{' '}
      <span title={metricColumn}>{fieldLabel(metricColumn, 'activePlanning')}</span>
    </span>
  );

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      <StatCard title="Reorder Date" stat={period} subtitle="Planning decision date" />
      <StatCard
        title="SKUs At Risk of Stockout"
        stat={summary?.understocked ?? '—'}
        statColor="negative"
        subtitle={`understocked${stateSuffix}`}
        tag={comparedTag}
      />
      <StatCard
        title="SKUs Overstocked"
        stat={summary?.overstocked ?? '—'}
        statColor="amber"
        subtitle={`overstocked${stateSuffix}`}
        tag={comparedTag}
      />
    </div>
  );
}
